/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Producer_CreatedInputs */

const en_producer_created = /** @type {(inputs: Producer_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producer created`)
};

const es_producer_created = /** @type {(inputs: Producer_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productor creado`)
};

/**
* | output |
* | --- |
* | "Producer created" |
*
* @param {Producer_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const producer_created = /** @type {((inputs?: Producer_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Producer_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_producer_created(inputs)
	return es_producer_created(inputs)
});